import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Chip,
} from '@mui/material';
import { useState } from 'react';
import useAppStore from '@/store/app';
import { toast } from 'react-toastify';
import { useRouteLoaderData } from 'react-router-dom';
import useTenantMutation from '@/hooks/useTenantMutation';
import ToastMessage from '@/components/toasts/ToastMessage';

export default function TenantTeamDialog() {
  const { setDialogForm } = useAppStore();

  const { users } = useRouteLoaderData('auth');
  const [team, setTeam] = useState({
    title: '',
    managers: [],
    members: [],
    type: null,
  });

  const { mutateAsync: createTeam } = useTenantMutation('team');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTeam((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleManagerChange = (event) => {
    const { value } = event.target;
    setTeam((prevData) => ({
      ...prevData,
      managers: value,
      members: prevData.members.filter((member) => !value.includes(member)),
    }));
  };

  const handleMembersChange = (event) => {
    const { value } = event.target;
    setTeam((prevData) => ({
      ...prevData,
      members: value,
      managers: prevData.managers.filter(
        (managers) => !value.includes(managers),
      ),
    }));
  };

  const saveAccountData = async () => {
    if (
      !team.title ||
      team.managers.length === 0 ||
      team.members.length === 0
    ) {
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle="Alle Felder müssen ausgefüllt werden!"
        />,
      );
      return;
    }

    const teamData = {
      ...team,
      type: team.type || null,
    };
    await createTeam(teamData);
    handleCloseDialog();
  };

  const handleCloseDialog = () => {
    setDialogForm(null);
  };

  const availableManagers =
    users?.filter((user) => !team.members.includes(user._id)) || [];

  const availableMembers =
    users?.filter((user) => !team.managers.includes(user._id)) || [];

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 200,
      },
    },
  };

  return (
    <Dialog open={true} onClose={handleCloseDialog} fullWidth maxWidth="sm">
      <DialogTitle>Team hinzufügen</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            width: '100%',
            pt: 2,
          }}
        >
          <TextField
            required
            fullWidth
            label="Name"
            name="title"
            value={team.title}
            variant="outlined"
            onChange={handleChange}
          />

          <FormControl fullWidth>
            <InputLabel id="managers-select-label">Manager</InputLabel>
            <Select
              labelId="managers-select-label"
              id="managers-select"
              multiple
              value={team.managers}
              onChange={handleManagerChange}
              input={<OutlinedInput label="Manager" />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((id) => {
                    const user = users.find((u) => u._id === id);
                    return (
                      <Chip
                        key={id}
                        label={`${user.firstName} ${user.lastName}`}
                      />
                    );
                  })}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {availableManagers.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {`${user.firstName} ${user.lastName}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="members-select-label">Mitglieder</InputLabel>
            <Select
              labelId="members-select-label"
              id="members-select"
              multiple
              value={team.members}
              onChange={handleMembersChange}
              input={<OutlinedInput label="Mitglieder" />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((id) => {
                    const user = users.find((u) => u._id === id);
                    return (
                      <Chip
                        key={id}
                        label={`${user.firstName} ${user.lastName}`}
                      />
                    );
                  })}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {availableMembers.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {`${user.firstName} ${user.lastName}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="type-select-label">Typ</InputLabel>
            <Select
              labelId="type-select-label"
              id="type-select"
              value={team.type || ''}
              onChange={handleChange}
              name="type"
              input={<OutlinedInput label="Typ" />}
            >
              <MenuItem value="">Kein Typ</MenuItem>
              <MenuItem value="ORG_UNIT">Organisationseinheit</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>Schließen</Button>
        <Button onClick={saveAccountData} variant="contained">
          Hinzufügen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
